import React from 'react'
import Select from 'Components/Select'
import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Switch from 'Components/Switch'
import Form from 'Components/Form'

import PhoneInput from 'Components/PhoneInput'
import Datagrid from 'EurestoComponents/Datagrid'
import moment from 'moment'
import EurestoDiv from 'EurestoComponents/EurestoDiv'

import Utils from 'EurestoFonction/Utils'
import Data from "EurestoClass/Data";
import Constants from "EurestoFonction/Constants";

moment.locale('fr')

export default class Adresses extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      coordonnees: props.data,
      coordonnee: props.data && props.data[0] || {},
      index: (props.data || []).length > 0 ? 0 : undefined,
      action: 'view',
      key: Utils.getRandomNumber(),
      key_grid: Utils.getRandomNumber(),
      datagridId: Utils.getRandomNumber(),
      position: 0
    }
  }

  componentDidUpdate() {
    $('#' + this.state.datagridId + '-body').scrollTop(this.state.position)
  }

  callChangeProps = type => _ => {
    let name
    let data
    if (type === 0 || type === undefined) {
      name = 'adresses'
      data = this.state.coordonnees.filter(c => c.type === 0 || c.type === undefined)
    } else if (type === 1) {
      name = 'mails'
      data = this.state.coordonnees.filter(c => c.type === 1)
    } else {
      name = 'telephones'
      data = this.state.coordonnees.filter(c => c.type !== 0 && c.type !== undefined && c.type !== 1 && c.type !== undefined)
    }
    this.props.onChange(data, name)
  }

  onSave = () => {
    let coordonnee = this.state.coordonnee || {}
    if (this.state.index === undefined) {
      let coordonnees = this.state.coordonnees || []
      coordonnees.push(coordonnee)
      this.setState({
        coordonnees: coordonnees,
        action: 'view',
        index: coordonnees.length - 1,
        position: $('#' + this.state.datagridId + '-body').scrollTop(),
        key_grid: Utils.getRandomNumber(),
        key: Utils.getRandomNumber()
      }, this.callChangeProps(coordonnee.type))
    } else {
      this.setState({
        action: 'view',
        position: $('#' + this.state.datagridId + '-body').scrollTop(),
        key_grid: Utils.getRandomNumber(),
        key: Utils.getRandomNumber()
      }, this.callChangeProps(coordonnee.type))
    }
  }

  onView = i => _ => {
    let coordonnees = this.state.coordonnees || []
    const index = (this.state.coordonnees || []).length > 0 ? i || 0 : undefined
    this.setState({
      index: index,
      coordonnee: index >= 0 && coordonnees[index] || {},
      action: 'view',
      position: $('#' + this.state.datagridId + '-body').scrollTop(),
      key: Utils.getRandomNumber()
    })
  }

  onChange = (data, name) => {
    let coordonnee = this.state.coordonnee || {}
    coordonnee[name] = data
    this.setState({
      coordonnee: coordonnee
    })
  }

  onDelete = _ => {
    const coordonnee = this.state.coordonnee
    let coordonnees = this.state.coordonnees || []
    coordonnees.splice(this.state.index, 1)
    const index = (this.state.coordonnees || []).length > 0 ? 0 : undefined
    this.setState({
      index: index,
      coordonnees: coordonnees,
      coordonnee: index >= 0 && coordonnees[index] || {},
      action: 'view',
      key_grid: Utils.getRandomNumber(),
      position: $('#' + this.state.datagridId + '-body').scrollTop(),
      key: Utils.getRandomNumber()
    }, this.callChangeProps(coordonnee.type))
  }

  onCancel = _ => {
    this.setState({
      coordonnee: {},
      action: 'add',
      index: undefined,
      key: Utils.getRandomNumber()
    })
  }

  form = (disabled, autoFocus) => (
    <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0}>
      <Grid item xs={6} style={{ margin: 0, padding: 0, paddingRight: 2.5 }}>
        <Select
          default={0}
          autoComplete={false}
          title={'Type'}
          name={'type'}
          disabled={disabled}
          onChange={this.onChange}
          options={[
            {
              value: 0,
              label: 'Adresse'
            },
            {
              value: 1,
              label: 'Email'
            },
            {
              value: 2,
              label: 'Portable'
            },
            {
              value: 3,
              label: 'Fixe'
            },
            {
              value: 4,
              label: 'Fax'
            }
          ]}
          value={this.state.coordonnee.type}
        />
      </Grid>
      <Grid item xs={6} style={{ margin: 0, padding: 0, paddingLeft: 2.5 }}>
        <Input title={'Intitulé'}
          name={'libelle'}
          autoFocus={autoFocus}
          disabled={disabled}
          onChange={this.onChange}
          value={this.state.coordonnee.libelle}
        />
      </Grid>
      <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
        {(this.state.coordonnee.type === 0 || this.state.coordonnee.type === undefined) &&
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="center"
            alignItems="stretch">
            <Input title={'Adresse'}
              disabled={disabled}
              name={'adresse1'}
              onChange={this.onChange}
              value={this.state.coordonnee.adresse1}
            />
            <Input disabled={disabled}
              name={'adresse2'}
              onChange={this.onChange}
              value={this.state.coordonnee.adresse2}
            />
            <Input disabled={disabled}
              name={'adresse3'}
              onChange={this.onChange}
              value={this.state.coordonnee.adresse3}
            />
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
              <Grid item style={{ margin: 0, padding: 0 }} md={12} lg={3}>
                <Input title={'CP'}
                  disabled={disabled}
                  name={'cp'}
                  onChange={this.onChange}
                  value={this.state.coordonnee.cp}
                />
              </Grid>
              <Grid item style={{ margin: 0, padding: 0 }} md={12} lg={9}>
                <Input title={'Ville'}
                  disabled={disabled}
                  name={'ville'}
                  onChange={this.onChange}
                  value={this.state.coordonnee.ville}
                />
              </Grid>
            </Grid>
            <Switch
              onChange={this.onChange}
              disabled={disabled}
              name="npai"
              checked={this.state.coordonnee.npai}
              label={EurestoI18n.t('crm:NPAI')} />
            <Switch
              onChange={this.onChange}
              disabled={disabled}
              name="facturation"
              checked={this.state.coordonnee.facturation}
              label={EurestoI18n.t('crm:Facturation')} />
            <Switch
              onChange={this.onChange}
              disabled={disabled}
              name="livraison"
              checked={this.state.coordonnee.facturation}
              label={EurestoI18n.t('crm:Livraison')} />
          </Grid>
          ||
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="center"
            alignItems="stretch">
            {(this.state.coordonnee.type === 2 || this.state.coordonnee.type === 3) ? <PhoneInput onChange={this.onChange} name='valeur' inline disabled={disabled}
              value={this.state.coordonnee.valeur} title={EurestoI18n.t('crm:Fixe')} /> :
              <Input
                onChange={this.onChange}
                disabled={disabled}
                name="valeur"
                type={(this.state.coordonnee.type === 2 || this.state.coordonnee.type === 3) && 'phone' || 'text'}
                value={this.state.coordonnee.valeur}
              />}
          </Grid>
        }
      </Grid>

      <Grid key={this.state.key + 'update_add_coordonnee'} container style={{ margin: 0, padding: 0 }} spacing={0}
        justify={'flex-start'}
        alignItems={'flex-start'} alignContent={'flex-start'} direction={'column'}>
        <span className={'EurestoSecondary--text'} style={{ textAlign: 'left', fontSize: 11, color: 'lightgreen' }}><i className={'ei-commun_ajouter'} />{this.state.coordonnee.date_creation &&
          (this.state.coordonnee.date_creation && moment(this.state.coordonnee.date_creation).format('DD/MM/YY HH:mm:ss') || '')
          + (this.state.coordonnee.libelle_user_creation && (', ' + this.state.coordonnee.libelle_user_creation) || '')}</span>
        <span className={'EurestoPrimary--text'} style={{ textAlign: 'left', fontSize: 11, color: 'lightblue' }}><i className={'ei-commun_modifier'} />{this.state.coordonnee.date_modification &&
          (this.state.coordonnee.date_modification && moment(this.state.coordonnee.date_modification).format('DD/MM/YY HH:mm:ss') || '')
          + (this.state.coordonnee.libelle_user_modification && (', ' + this.state.coordonnee.libelle_user_modification) || '')}</span>
      </Grid>
    </Grid>
  )

  columns = [
    {
      Header: 'id',
      accessor: 'id',
      show: false
    }, {
      Header: () => EurestoI18n.t('crm:Type'),
      id: 'type',
      sortable: true,
      width: 50,
      accessor: 'type',
      Cell: row => {
        return (<Grid item style={{ margin: 0, padding: 7.5, width: 40, fontSize: 20 }} className={' ' +
          ((row.original.type === 0 || row.original.type === undefined) && 'ei-commun_envoyer'
            || row.original.type === 1 && 'ei-crm_campagne_email'
            || row.original.type === 2 && 'ei-crm_campgne_sms'
            || row.original.type === 3 && 'ei-action_appel_entrant'
            || row.original.type === 4 && 'fa fa-fax' || '')} />)
      }
    }, {
      Header: () => EurestoI18n.t('crm:Contact'),
      id: 'libelle',
      width: 100,
      sortable: true,
      accessor: 'libelle',
      Cell: row => {
        return <Grid item style={{
          margin: 0, padding: 5, height: '100%', textAlign: 'left',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}>{row.original.libelle}</Grid>
      }
    }, {
      Header: '',
      id: 'valeur',
      sortable: true,
      accessor: 'valeur',
      Cell: row => {
        return <Grid item style={{
          margin: 0, padding: 5, height: '100%', textAlign: 'left',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}>{(row.original.type === 0 || row.original.type === undefined) &&
          ((row.original.adresse1 && row.original.adresse1 || '')
            + (row.original.adresse1 && (row.original.cp || row.original.ville) && ', ')
            + (row.original.cp && row.original.cp || '')
            + (row.original.cp && row.original.ville && ', ')
            + row.original.ville)
          || row.original.valeur}</Grid>
      }
    }, {
      Header: () => EurestoI18n.t('crm:Modifiée le'),
      id: 'date_modification',
      maxWidth: 80,
      accessor: 'date_modification',
      Cell: row => (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'}>
          {row.original.date_modification && moment(row.original.date_modification).format('DD/MM/YY') || ''}
        </Grid>
      )
    }
  ]

  render() {
    return (
      <EurestoDiv id={'onglet_contact_coordonnees'} title='Coordonnées Complémentaires' expandable expanded={this.props.data.length > 0}>
        <Grid container spacing={0}
          style={Object.assign({ margin: 0, padding: 0, position: 'relative' }, this.props.style || {})}
          justify={'center'} alignContent={'flex-start'} alignItems={'flex-start'}>
          <Grid item xs={9} style={{ margin: 0, padding: 0 }}>
            <Datagrid key={this.state.key_grid + '_datagrid'} columnsName={this.columns} data={this.state.coordonnees}
              isSubComponent={true} filterable={false}
              indexSelected={this.state.index}
              id={this.state.datagridId}
              style={{
                maxHeight: this.props.maxHeight
              }}
              onClick={(row, index) => this.onView(index)()}
              defaultSorted={[{
                id: 'type'
              }
              ]} />
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 0, height: '100%' }}>
            <Form key={this.state.key + '_form'}
              borderLeft
              onClickUpdate={!this.props.disabled}
              libelle={this.state.index >= 0 && this.state.coordonnees[this.state.index].libelle}
              style={{ padding: 0 }}
              showTab={false}
              action={this.state.action}
              isAllow={{
                add: !this.props.disabled,
                update: (this.state.coordonnees || []).length > 0 && !this.props.disabled,
                delete: this.state.index >= 0 && !this.props.disabled
              }}
              onSave={this.onSave}
              onCancel={this.onCancel}
              onDelete={this.onDelete}
              onView={this.onView(this.state.index)}
              libelleAdd={EurestoI18n.t('commun:Nouvelle coordonnées')}
              children={this.form} />
          </Grid>
        </Grid>
      </EurestoDiv>)
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Coordonnee/index.js